import { render } from "./CameraGroupName.vue?vue&type=template&id=ccfeaea0&ts=true"
import script from "./CameraGroupName.vue?vue&type=script&lang=ts"
export * from "./CameraGroupName.vue?vue&type=script&lang=ts"

import "./CameraGroupName.vue?vue&type=style&index=0&id=ccfeaea0&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__